import {NgModule} from '@angular/core';
import {VideoDialogMenuComponent} from './video-dialog-menu.component';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {FormsModule} from '@angular/forms';

@NgModule({
  exports: [
    VideoDialogMenuComponent,
  ],
  declarations: [
    VideoDialogMenuComponent,
  ],
  imports: [
    MatButtonModule,
    TranslateModule,
    MatSlideToggleModule,
    FormsModule,
  ],
})

export class VideoDialogMenuModule {}
